var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.breakdown.getName()))]),_c('PieChart',{staticClass:"pie-chart",attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }